// src/context/AppContext.js
import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [clipboardData, setClipboardData] = useState(null);

  const copyToClipboard = (data) => {
    setClipboardData(data);
  };

  const clearClipboard = () => {
    setClipboardData(null);
  };

  return (
    <AppContext.Provider value={{ clipboardData, copyToClipboard, clearClipboard }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);